import * as actionTypes from './actionTypes';

export const refreshTasks = () => {
  return { type: actionTypes.REFRESH_TASKS };
};

export const refreshLabels = () => {
  return { type: actionTypes.REFRESH_LABELS };
};

export const refreshUser = () => {
  return { type: actionTypes.REFRESH_USER };
};

export const refreshShowGlobalTasksAsList = () => {
  return { type: actionTypes.REFRESH_SHOW_GLOBAL_TASKS_AS_LIST };
};

export const refreshDisableTasksDone = () => {
  return { type: actionTypes.REFRESH_DISABLE_TASKS_DONE };
};

export const refreshDisableAdviceShow = () => {
  return { type: actionTypes.REFRESH_DISABLE_ADVICE_SHOW };
};

export const refreshLanguage = () => {
  return { type: actionTypes.REFRESH_LANGUAGE };
};
